<template>
	<div data-element="search-container">
		<form
			data-component="search-input"
			v-on:submit.prevent
		>
			<input
				v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
				v-modify-input-leading="{ modifyInputLeading: $store.getters['ui/getBodyCopyFontInputLeading'] }"
				data-element="input"
				type="text"
				name="query"
				aria-label="Search for products in menu"
				v-bind:value="searchQuery"
				v-on:input="updateSearchQuery($event.target.value)"
				placeholder="Search"
			/>
		</form>
		<icon
			v-if="!searchQuery"
			icon="search"
			size="sm"
			data-element="icon"
			alt="Search"
		/>
		<div
			v-else
			data-element="icon-container"
			@click="closeSearch"
		>
			<icon
				icon="close"
				size="sm"
				data-element="close-icon"
				alt="Clear search field"
			/>
		</div>
	</div>
</template>

<script>
	import Icon from '@/components/ui/Icon';

	export default {
		components: {
			Icon
		},
		props: [
			'menu',
			'searchQuery',
			'updateSearchQuery',
			'closeSearch'
		],
	}


</script>

<style lang="scss">
	@import '@/assets/scss/variables.scss';
	@import '@/assets/scss/helpers.scss';

	[data-element='search-container'] {
		position:relative;
		height:48px;
		width:100%;
		[data-component='search-input'] {
			height:100%;
			width:100%;
			[data-element='input'] {
				width:100%;
				height:100%;
				border:1px solid #000;
				font-size:16px;
				font-weight:500;
				background-color:#fff;
				padding:8px 9px 6px 8px;
				border-radius:0;
				&::placeholder {
					color:$black;
				}
				&:focus {
					padding:8px 3px 6px 8px;
					outline:none;
				}
				&::placeholder {
					color:$black;
				}
				&:focus::-webkit-input-placeholder { color:transparent; }
				&:focus:-moz-placeholder { color:transparent; } /* FF 4-18 */
				&:focus::-moz-placeholder { color:transparent; } /* FF 19+ */
				&:focus:-ms-input-placeholder { color:transparent; } /* IE 10+ */
				&:focus {
					padding:4px 3px 6px 8px;
					outline:none;
					border-width:2px;
				}
				&::-ms-clear {
					display: none;
				}
			}
			@include whenScreenIs(md) {
				margin-bottom:8px;
			}
		}
		[data-element='icon'],
		[data-element='icon-container'] {
			position:absolute;
			right:8px;
			top:50%;
			transform:translateY(-50%);
		}
		[data-element='icon-container'] {
			height:100%;
			width:30px;
			display:flex;
			align-items:center;
			justify-content:flex-end;
			[data-element='close-icon'] {

			}
		}
	}

</style>
